export const ARTICLE_PAGE_SIZE = 12;
export const ARTICLE_RECOMENDATIONS_PAGE_SIZE = 5;
